<template >
    <div class="cat-block-pr" :id="question.post_slug" >
        <div class="categories-content-blocks">
            <router-link tag="a" :to="{name: 'question', params: { lang: $route.params.lang } , hash: '#' + question.post_slug}" class="categories-content-expand " data-toggle="collapse"  role="button" aria-expanded="false" :data-target="'#collapse-' + question.post_slug" :aria-controls="'#' + question.post_slug">
                <span>{{ question.post_title }}</span>
                <span class="circle-expand"><i class="ipic_arrow-d"></i></span>
            </router-link>
            <div class="collapse collapse_element" :id="'collapse-' + question.post_slug" data-parent="#accordion">
                <div class="categories-content-collapsed" v-html="question.content">
                    
                </div>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    props: ['question'],
    data: () => {
        return {
        }
    },
    
}
</script>